export function getCatalogVisibilityBadges(product) {
  if (!product || typeof product !== "object") {
    return [];
  }

  const badges = [];
  if (product.isDeleted === 1) {
    badges.push({ label: "Eliminato", color: "#e00036" });
  }
  if (product.isDisattivato === 1) {
    badges.push({ label: "Disattivato", color: "#ed6c02" });
  }
  return badges;
}

export const CATALOG_VISIBILITY_FILTERS = {
  ALL: "all",
  DEACTIVATED: "deactivated",
  DELETED: "deleted",
};

export function mapCatalogVisibilityFilterToRequest(visibilityFilter) {
  if (visibilityFilter === CATALOG_VISIBILITY_FILTERS.DEACTIVATED) {
    return { soloDisattivati: true };
  }
  if (visibilityFilter === CATALOG_VISIBILITY_FILTERS.DELETED) {
    return { soloEliminati: true };
  }
  return {};
}
